<template>
  <div class="now-playing">
    <div
      ref="playlist"
      class="playlist">
      <el-row
        type="flex"
        align="middle"
        class="up-next-title">
        <span>
          <img
            class="list-icon"
            src="../assets/images/ic_up_next_2x.png">
        </span>
        <span>
          Up Next
        </span>
      </el-row>
      <el-row
        v-for="episode in playlist"
        :key="episode.uuid"
        type="flex"
        align="middle"
        justify="space-between"
        class="playlist-item">
        <div>
          <el-row
            type="flex"
            align="middle">
            <div class="episode-img-holder">
              <div class="overlay"/>
              <img
                v-if="!episode.is_playing"
                src="../assets/images/ic_play_symbol_white.svg"
                class="play-button"
                @click="playEpisode(episode)">
              <img
                v-if="episode.is_playing"
                src="../assets/images/ic_player_pause.svg"
                class="play-button"
                @click="playEpisode(episode)">
              <img
                :src="episode.image_url ?
                  episode.display_image_url :
                  (episode.season.podcast.image_url ?
                episode.season.podcast.display_image_url : imgPlaceholder)"
                class="episode-img">
            </div>
            <div>
              <div class="playlist-episode-title t-ellipsis">
                <router-link
                  :to="`/listen/${episode.season.podcast.publisher.slug}/${episode.season.podcast.slug}/${episode.slug}/${episode.uuid}`"
                  class="episode-title">{{ episode.title }}</router-link> <br >
                <router-link
                  v-if="episode && episode.season && episode.season.podcast.uuid"
                  :to="`/listen/${episode.season.podcast.publisher.slug}/${episode.season.podcast.slug}/${episode.season.podcast.uuid}`"
                  class="podcast-title">
                  <span v-if="episode && episode.season">{{ episode.season.podcast.title }}</span>
                </router-link>
              </div>
            </div>
          </el-row>
        </div>
        <div class="t-r">
          <img
            class="arrow"
            src="../assets/images/ic_arrow_forward.svg"
            @click="playEpisode(episode)">
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import * as log from 'loglevel';
import PlaybackService from '../services/PlaybackService';
import Episode from '../services/Episode';
import Podcast from '../services/Podcast';
import imgPlaceholder from '../assets/images/placeholder.png';

export default {
  name: 'Playlist',
  data() {
    return {
      episodeProvider: null,
      playbackService: null,
      imgPlaceholder,
      currentPlaying: {},
      playlist: [],
      type: 'show',
      showPlaylist: false,
      podcast_service: new Podcast(),
      page_size: 25,
      current_page: 1,
      no_more_data: false,
      isFetchingPlaylist: false,
      stopAutoPlay: false,
      encoded_list: '',
    };
  },
  watch: {
    /* eslint-disable */
    '$store.getters.currentPlaylingEpisodeId': function (newVal) {
      if (!this.playlist || !this.playlist.length) {
        return;
      }
      if (newVal) {
        const targetindex = this.playlist.findIndex(episode => episode.uuid === newVal);
        if (targetindex && targetindex > -1) { this.$set(this.playlist[targetindex], 'is_playing', true); }
      } else {
        const targetindex = this.playlist.findIndex(episode => episode.uuid === this.currentPlaying.uuid);
        if (targetindex && targetindex > -1) this.$set(this.playlist[targetindex], 'is_playing', false);
      }
    },
    '$store.getters.playlist': function (newVal) {
      if (newVal && newVal.length) {
        this.playlist = newVal;
        this.filterSkippedEpisodes();
      }
    },
    '$store.getters.episode': function (newVal, oldVal) {
      const { playlistType } = this.$store.getters;
      if (newVal.uuid !== oldVal.uuid || playlistType !== this.type) {
        this.currentPlaying = newVal;
        this.type = this.$store.getters.playlistType;
        setTimeout(() => {
          this.fetchPlayList();
        });
      }
      // TRYING
      if (this.$store.getters.playlistType === 'continue_listening') {
        this.$store.dispatch('setContinuousListeningActiveEpisode', newVal);
      }

      // TRYING TO SWAP ITEMS SO THAT ACTIVE ITEMS SHOW AT 0 INDEX
      const CL = this.$store.getters.continueListeningPlaylist;
      const continueListeningSelectedIndex = CL.findIndex(item => item.season.podcast.uuid === newVal.season.podcast.uuid);
      if (continueListeningSelectedIndex > -1) {
        const obj = CL.splice(continueListeningSelectedIndex, 1)[0];
        CL.unshift(obj);
        this.$store.dispatch('setContinueListeningPlaylist', CL);
      }
    },
    '$store.getters.status': function (newVal) {
      if (newVal === 'ended') {
        this.getNextEpisode();
      }
    },
    /* eslint-enable */
  },
  mounted() {
    this.episodeProvider = new Episode();
    this.playbackService = new PlaybackService();
  },
  methods: {
    playEpisode(episode) {
      if (episode.uuid === this.currentPlaying.uuid) {
        if (episode.is_playing) {
          // window.eventBus.$emit('pause-podcast')
          this.$store.dispatch('pause');
          this.markCurrentEpisode(false);
          return;
        }
      }
      // this.$store.dispatch('play')
      this.$store.dispatch('setEpisode', episode);
      // this.playPodcast(episode)
    },
    fetchPlayList() {
      const { loadPlaylist } = this.$store.getters;
      if (!loadPlaylist) {
        return;
      }
      switch (this.type) {
        case 'show':
          // TODO: Fetch current show episodes
          this.fetchAllShowEpisodes();
          break;
        case 'trailers':
          break;
        case 'continue_listening':
          this.fetchContinupusListeningPlaylist();
          break;
        case 'my_shows':
          this.fetchAllPodcastsEpisodes();
          break;
        case 'my_episodes':
          this.fetchMyEpisodes();
          break;
        default:
          // TODO: Fetch current show episodes
      }
    },

    fetchMyEpisodes() {
      const limit = 25;
      const page = 1;
      this.fetchLibraryEpisodes(page, limit);
    },
    fetchAllPodcastsEpisodes() {
      this
        .episodeProvider.getAllPodcastEpisodes().then((resp) => {
          this.$store.dispatch('setPlaylist', resp);
        })
        .catch((error) => {
          log.warn(error);
        });
    },
    fetchLibraryEpisodes(page, limit) {
      this.episodeProvider
        .getEpisodesFromLibrary(limit, page)
        .then((response) => {
          response.sort((a, b) => a.position - b.position);
          const playlist = response.map(elem => elem.episode);
          this.playlist = playlist;
          this.$store.dispatch('setLoadPlaylist', false);
          this.$store.dispatch('setPlaylist', this.playlist);
        })
        .catch((error) => {
          log.warn(error, ' --> error (Episodes)');
        });
    },
    getNextEpisode() {
      const currentEpisode = this.$store.getters.episode;
      const nextEpisode = this.playbackService.getNextEpisode(currentEpisode);
      if (nextEpisode) {
        this.$store.dispatch('setAndPlayEpisode', nextEpisode);
      } else {
        // If next episode is not found trigger continuous listening logic
        this.triggerContinuousListening();
      }
    },
    triggerContinuousListening() {
      this.playbackService
        .getContinuousListeningShowLevelPlayList()
        .then((resp) => {
          if (resp && resp.length) {
            const continuousListeningFirstEpisode = resp[0];
            this.$store.dispatch('setLoadPlaylist', true);
            this.$store.dispatch('setPlaylistType', 'continue_listening');
            this.$store.dispatch('setContinueListeningPlaylist', resp);
            this.$store.dispatch('setContinuousListeningActivePodcast', continuousListeningFirstEpisode.season.podcast.uuid);
            if (continuousListeningFirstEpisode && continuousListeningFirstEpisode.uuid) {
              const currentEpisode = this.$store.getters.episode;
              if (currentEpisode.uuid === continuousListeningFirstEpisode.uuid && continuousListeningFirstEpisode.progress > 95) {
                this.getNextEpisode();
              } else {
                this.$store.dispatch('setAndPlayEpisode', continuousListeningFirstEpisode);
              }
            }
          }
        })
        .catch((error) => {
          log.warn(error);
        });
    },
    fetchContinupusListeningPlaylist() {
      // This will fetch all episodes of currently active podcast of continuous listening
      let currentActivePodcast = this.$store.getters.continuousListeningActivePodcast;
      if (!currentActivePodcast) {
        currentActivePodcast = this.$store.getters.episode.season.podcast.uuid || '';
      }
      this.podcast_service.getPodcastEpisodesByPodcastId(currentActivePodcast)
        .then((episodes) => {
          if (episodes && episodes.length) {
            this.$store.dispatch('setPlaylist', episodes);
            this.$store.dispatch('setLoadPlaylist', false);
          }
        })
        .catch((error) => {
          log.warn(error);
        });
    },
    fetchAllShowEpisodes() {
      this.podcast_service.getPodcastEpisodesByPodcastId(this.currentPlaying.season.podcast.uuid)
        .then((episodes) => {
          if (episodes && episodes.length) {
            this.$store.dispatch('setPlaylist', episodes);
          }
        })
        .catch((error) => {
          log.warn(error);
        });
    },
    filterSkippedEpisodes() {
      const currentEpisode = this.$store.getters.episode;
      const currentIndex = this.playlist.findIndex(episode => episode.uuid === currentEpisode.uuid);
      if (currentIndex < 0) {
        return;
      }
      const upNextPlaylist = this.playlist.slice(currentIndex);
      this.playlist = upNextPlaylist;
    },
  },
};
</script>
<style lang="scss">
  @import "../assets/scss/variables.scss";
  .now-playing {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #666666;

    .title {
      font-size: 14px;
      margin: 0px;
    }
  }
  .episode-img {
    width: 48px;
    height: 48px;
  }
  .playlist{
    max-height: 386px;
    overflow-y: auto;
    width: 100%;
    font-family: Favorit;
    letter-spacing: 0.4px;
    font-weight: bold;
    .list-icon{
      width: 24px;
      margin-right: 16px;
    }
    .episode-title{
      font-size: 16px;
      color: #ffffff;
      font-weight: normal;
      line-height: 20px;
    }
    .podcast-title{
      font-size: 14px;
      color: #BABABA;
      font-weight: 500;
      line-height: 18px;
    }
    .up-next-title{
      font-size: 16px;
      font-weight: normal;
      font-family: Favorit;
      letter-spacing: 0.4px;
      line-height: 20px;
      padding: 16px 0 8px 0;
    }
  }
  .playlist::-webkit-scrollbar-track {
    border: 1px solid #666666;
    padding: 2px 0;
    background-color: #666666;
    visibility: hidden;
  }

  .playlist::-webkit-scrollbar {
    width: 5px;
    visibility: hidden;
  }

  .playlist::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(48, 65, 69, 0.88);
    border: 1px solid rgba(48, 65, 69, 0.88);
    visibility: hidden;
  }

  .playlist-item {
    cursor: pointer;
    padding: 8px 0px;
    .arrow{
      width: 24px;
      height: 24px;
    }
    .playlist-episode-title{
      width: 450px;
      font-family: Favorit;
      letter-spacing: 0.85px;
      font-weight: 500;
      a{
        font-family: Favorit;
        letter-spacing: 0.85px;
        font-weight: 500;
      }
    }
    .episode-img-holder{
      width: 48px;
      height: 48px;
      position: relative;
      margin-right: 8px;
      .overlay{
        position: absolute;
        z-index: 999;
        background: rgba(0, 0, 0, 0.6);
        top: 0;
        left: 0;
        width: 48px;
        height: 48px;
      }
      .play-button{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 16px;
        height: 16px;
        transform: translate(-50%, -50%);
        z-index: 10000;
      }
    }
  }

  .playlist-close {
    float: right;
    cursor: pointer;
  }
  @media (max-width: 567px) {
    .playlist{
      max-height: 344px;
      overflow-y: auto;
    }
    .playlist-item{
      .playlist-episode-title{
        width: 220px;
      }
    }
    .now-playing > div{
      margin: auto;
    }
  }
  @media (max-width: 992px) and (min-width: 768px)  {
    .playlist{
      max-height: 384px;
    }
  }

</style>



// WEBPACK FOOTER //
// app/src/components/Playlist.vue